module.exports = __webpack_public_path__ + "media/images/npcc_logo_light-5d30cff3231b710dabab1b21e07a0e98.png";